import { getErrorMessage } from '@juvare/common-web-ui/utils';
import { getDataValue } from '@juvare/json-data-util';
import { mapToArray } from '@juvare/widget-ui/Utils';
function validate(sections, config, data, validateFunctionType) {
    var _a, _b, _c;
    const validationResult = {
        totalFieldCount: 0,
        completedFieldCount: 0,
        incompleteSections: [],
        errorSections: [],
    };
    let invalidFieldCount = 0;
    for (const section of sections) {
        let validateFunction = undefined;
        const js = section.columns[validateFunctionType];
        if (js) {
            try {
                validateFunction = Function('"use strict"; return (function(data, globals) { const { checkDataValueExists } = globals; ' + js + '; })')();
            }
            catch (error) {
                validationResult.errorSections.push({
                    id: section.id,
                    error: getErrorMessage(error),
                });
            }
        }
        else if (section.columns.key) {
            validateFunction = (_a = config === null || config === void 0 ? void 0 : config[validateFunctionType]) === null || _a === void 0 ? void 0 : _a[section.columns.key];
        }
        if (validateFunction) {
            try {
                const sectionValidationResult = validateFunction(data, { checkDataValueExists });
                validationResult.totalFieldCount += (_b = sectionValidationResult.validatedFieldCount) !== null && _b !== void 0 ? _b : 0;
                if (sectionValidationResult.incompleteFields && sectionValidationResult.incompleteFields.length > 0) {
                    validationResult.incompleteSections.push({
                        id: section.id,
                        validatedFieldCount: (_c = sectionValidationResult.validatedFieldCount) !== null && _c !== void 0 ? _c : 0,
                        incompleteFields: sectionValidationResult.incompleteFields,
                    });
                    invalidFieldCount += sectionValidationResult.incompleteFields.length;
                }
            }
            catch (error) {
                validationResult.errorSections.push({
                    id: section.id,
                    error: getErrorMessage(error),
                });
            }
        }
    }
    validationResult.completedFieldCount = validationResult.totalFieldCount - invalidFieldCount;
    return validationResult;
}
export function validateCompletion(sections, config, data) {
    return validate(sections, config, data, 'validateCompletion');
}
export function validateLogin(sections, config, data) {
    return validate(sections, config, data, 'validateLogin');
}
export function expandDataGridPath(data, path) {
    const indexOfFirstGrid = path.indexOf('.#.');
    if (indexOfFirstGrid !== -1) {
        const gridPath = path.substring(0, indexOfFirstGrid);
        const gridSize = mapToArray(getDataValue(data, gridPath)).length;
        const paths = [];
        for (let gridIndex = 0; gridIndex < gridSize; gridIndex++) {
            paths.push(...expandDataGridPath(data, gridPath + '.#' + gridIndex + '.' + path.substring(indexOfFirstGrid + 3)));
        }
        return paths;
    }
    else {
        return [path];
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function checkDataValueExists(data, path, validationFunction) {
    const expandedPaths = expandDataGridPath(data, path);
    if (expandedPaths.length > 0) {
        for (const expandedPath of expandedPaths) {
            if (validationFunction) {
                if (!validationFunction(getDataValue(data, expandedPath), path)) {
                    return false;
                }
            }
            else if (!getDataValue(data, expandedPath)) {
                return false;
            }
        }
        return true;
    }
    else {
        return false;
    }
}
